import React from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from 'react-query';
import { supplierService, Supplier } from '../../services/supplierService';

interface SupplierSelectProps {
  value?: number;
  onChange?: (value: number) => void;
  placeholder?: string;
  allowClear?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const SupplierSelect: React.FC<SupplierSelectProps> = ({
  value,
  onChange,
  placeholder = 'Chọn nhà cung cấp',
  allowClear = true,
  disabled = false,
  style,
}) => {
  const { data: suppliers = [], isLoading } = useQuery(
    'suppliers',
    supplierService.getSuppliers,
    {
      staleTime: 5 * 60 * 1000, // 5 phút
    }
  );

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      allowClear={allowClear}
      disabled={disabled}
      loading={isLoading}
      style={style}
      notFoundContent={isLoading ? <Spin size="small" /> : 'Không tìm thấy nhà cung cấp'}
      showSearch
      filterOption={(input, option) =>
        (option?.children as unknown as string)
          ?.toLowerCase()
          .includes(input.toLowerCase())
      }
    >
      {suppliers.map((supplier: Supplier) => (
        <Select.Option key={supplier.id} value={supplier.id}>
          {supplier.name} ({supplier.code})
        </Select.Option>
      ))}
    </Select>
  );
};

export default SupplierSelect; 